import React, { useContext } from "react";
import TransparentDivContext from "@/contexts/transparentDiv.context";
import areFlagsDisplayedContext from "@/contexts/areFlagsDisplayed.context";
import isUserMenuDisplayedContext from "@/contexts/userMenu.context";

const TransparentDiv = () => {
  //Transparent Div Context
  const { isTransparentDivDisplayed, setIsTransparentDivDisplayed } =
    useContext(TransparentDivContext);
  const { areFlagsDisplayed, setAreFlagsDisplayed } = useContext(
    areFlagsDisplayedContext
  );
  const { isUserMenuDisplayed, setIsUserMenuDisplayed } = useContext(
    isUserMenuDisplayedContext
  );

  const closeEverything = () => {
    setIsTransparentDivDisplayed(false);
    setAreFlagsDisplayed(false);
    setIsUserMenuDisplayed(false);
  };

  return (
    <div
      className="transparentDiv absolute h-screen w-screen z-40"
      onClick={(e) => closeEverything()}
    ></div>
  );
};

export default TransparentDiv;
